export const NOMINAL = 1
export const PERCENTAGE = 2
export const FIRST_NIGHT = 3
